import { useTranslation } from 'react-i18next'
import { User } from 'lucide-react'

import { SearchSelect } from '@/components/SearchSelect'

export interface UserSelectOption {
  id: string
  displayName: string
}

export interface UserSelectProps {
  /** User id, or '' for no selection. */
  value: string
  onChange: (userId: string) => void
  users: UserSelectOption[]
  /** Shows a spinner while the users load. */
  loading?: boolean
  /** Fires when the trigger is pressed — lets the caller fetch users lazily. */
  onOpen?: () => void
  placeholder?: string
  disabled?: boolean
  className?: string
}

/**
 * Searchable user picker. The caller owns the user list, so it can decide
 * when (and how widely) to fetch it.
 */
export function UserSelect({ users, placeholder, ...props }: UserSelectProps) {
  const { t } = useTranslation()
  return (
    <SearchSelect
      {...props}
      options={users.map((u) => ({ value: u.id, label: u.displayName }))}
      placeholder={placeholder ?? t('orders.selectUser')}
      clearable
      icon={User}
      searchPlaceholder={t('users.searchUsers')}
      emptyText={t('users.noUsersFound')}
    />
  )
}
